"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.Container = (0, styled_1.default)('div') `
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_large')};

  * {
    box-sizing: border-box;
  }
`;
exports.StyledContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
//# sourceMappingURL=styles.js.map